import Vue from 'vue'
import App from './App.vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

process.env.VUE_APP_PROJECT

import './assets/sass/main.css'

Vue.config.productionTip = false

import VueInsProgressBar from 'vue-ins-progress-bar'

import Toasted from 'vue-toasted';
Vue.use(Toasted, {
  position: "top-right", 
  theme: "bubble",
  duration : 3000,
  singleton : true,
})


Vue.use(BootstrapVue)
Vue.use(VueInsProgressBar, {
  position: 'fixed',
  show: true,
  height: '3px'
})

import { store } from '@/components/store/store'
import './utils/directives'

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

// Math.random().toString(36).substring(2, 12)